import styled from "styled-components";

import { FlexSection } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledHeroSection = styled(FlexSection)`
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    align-items: center;
    gap: 8px;
    padding: 48px 24px 32px 24px;
  }
`;

export const StyledImage = styled(Image)`
  height: 80px;
  width: 80px;

  @media only screen and (max-width: 600px) {
    height: 180px;
    width: 180px;
  }
`;

export const StyledTitle = styled(Typography)`
  color: ${theme.colorsV2.purple.shade_900};
  font-family: var(--man-800);
  margin: 16px 0 8px;

  @media only screen and (max-width: 600px) {
    letter-spacing: -2%;
    margin: 0;
    font-family: var(--man-700);
    text-align: center;
  }
`;

export const StyledSubtitle = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_600};
  font-size: 16px;
  line-height: 24px;
  font-family: var(--man-500);
  letter-spacing: 0.6px;
  white-space: pre-wrap;

  @media only screen and (max-width: 600px) {
    text-align: center;
  }
`;
